import type { FileUIPart } from "ai";
import type { PendingAttachment, UploadedAttachment } from "./types";

/**
 * Extra metadata we ride alongside the AI SDK's standard `FileUIPart`.
 * `solaUploadId` lets the server-side normaliser call back to Laravel
 * /sola/uploads/{id}/extract — much simpler than re-mapping URLs.
 */
export interface SolaProviderMetadata {
  sola: {
    uploadId: string;
    path: string;
    size: number;
  };
}

/**
 * Convert a tray of pending attachments into AI SDK FileUIPart[]. Only
 * fully-uploaded rows are emitted; pending/error rows are dropped (the UI
 * blocks send while uploads are in flight).
 */
export function toFileUIParts(pending: PendingAttachment[]): FileUIPart[] {
  return pending
    .filter((p): p is PendingAttachment & { uploaded: UploadedAttachment } =>
      p.status === "uploaded" && !!p.uploaded
    )
    .map(({ uploaded }) => ({
      type: "file",
      mediaType: uploaded.mediaType,
      filename: uploaded.filename,
      url: uploaded.url,
      providerMetadata: {
        sola: {
          uploadId: uploaded.id,
          path: uploaded.path,
          size: uploaded.size,
        },
      } as unknown as FileUIPart["providerMetadata"],
    }));
}
